// usePlatformFormLogic.ts
import { useEffect, useState } from "react";

import { UseFetchInformationWithGemini } from "0.Mine/1.Hooks/AI/Gemini";
import { Business } from "0.Mine/3.Interfaces/business";

export interface PlatformFormLogicProps {
  website: string;
  updateBusinessData: (data: Partial<Business>) => void;
  businessData: Partial<Business>;
}

export interface PlatformFormLogicReturn {
  platformName: string;
  platformType: "retail" | "service";
  setPlatformName: (value: string) => void;
  setPlatformType: (value: "retail" | "service") => void;
  ragioneSociale: string;
  setRagioneSociale: (value: string) => void;
}

export const usePlatformFormLogic = ({
  website,
  updateBusinessData,
  businessData,
}: PlatformFormLogicProps): PlatformFormLogicReturn => {
  const { fetchPrimaryInformationWithGemini } = UseFetchInformationWithGemini();
  const [platformName, setPlatformName] = useState<string>(businessData.name || "");
  const [platformType, setPlatformType] = useState<"retail" | "service">(
    (businessData.category as "retail" | "service") || "retail"
  );
  const [ragioneSociale, setRagioneSociale] = useState<string>(businessData.ragioneSociale || "");

  // Update the central business data when local state changes.
  useEffect(() => {
    updateBusinessData({ name: platformName, category: platformType });
  }, [platformName, platformType, updateBusinessData]);

  // Fetch platform information from Gemini when the website is provided.
  useEffect(() => {
    if (website) {
      const fetchData = async () => {
        try {
          const response = await fetchPrimaryInformationWithGemini(website);
          setPlatformName(response.name);
          setPlatformType(response.type);
        } catch (error) {
          console.error("ERROR IN PLATFORMFORM.TSX >>> ", error);
        }
      };
      fetchData();
    }
  }, [website, fetchPrimaryInformationWithGemini]);

  return {
    platformName,
    platformType,
    setPlatformName,
    setPlatformType,
    ragioneSociale,
    setRagioneSociale,
  };
};
